var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.grp_id === _vm.statement)?[_c('CommonStatementDocument',{attrs:{"grpId":_vm.grp_id}})]:_vm._e(),(_vm.grp_id === 'deviate')?[_c('CommonPreUpload',{attrs:{"lstDocumentDeviate":_vm.docList}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }